/**
 * Default max file size, 50MB
 */
export const DEFAULT_MAX_FILE_SIZE = 50 * 1024 * 1024;

/**
 * Default allowed types, empty = all allowed
 */
export const DEFAULT_ALLOWED_TYPES: string[] = [];

/**
 * Default parent folder for per-user files (e.g. userfiles => userfiles/{userId}/)
 */
export const DEFAULT_USER_FILES_FOLDER = 'userfiles';

/**
 * Default parent folder for avatars (e.g. avatars => avatars/{userId}/)
 */
export const DEFAULT_AVATARS_FOLDER = 'avatars';

/**
 * Default parent folder for imported prompt assets.
 */
export const DEFAULT_PROMPTS_FOLDER = 'prompts';

/**
 * Temporary public frame references for provider-side image-to-video fetches.
 */
export const DEFAULT_VIDEO_FRAME_REFS_FOLDER = 'video-frame-refs';

/**
 * Temporary public source assets for provider-side video editing.
 */
export const DEFAULT_VIDEO_EDIT_REFS_FOLDER = 'video-edit-refs';
/**
 * Public, admin-uploaded meme template assets (reference clips, previews,
 * audio). See scripts/template-assets.sh.
 */
export const DEFAULT_TEMPLATES_FOLDER = 'templates';

/** Temporary public video copies used while a provider fetches an input. */
export const DEFAULT_VIDEO_UPSCALE_INPUTS_FOLDER = 'video-upscale-inputs';
